var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["address-card", { primary: _vm.isPrimary }] },
    [
      !_vm.button
        ? [
            _c(
              "div",
              {
                staticClass: "address-card-wrapper",
                on: {
                  click: function($event) {
                    return _vm.$emit("on-edit")
                  }
                }
              },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v("\n        " + _vm._s(_vm.address.name) + "\n      ")
                ]),
                _c("div", { staticClass: "description" }, [
                  _vm._v("\n        " + _vm._s(_vm.details) + "\n      ")
                ]),
                _vm.isPrimary
                  ? _c("span", { staticClass: "label" }, [
                      _vm._v("\n        Основной\n      ")
                    ])
                  : _vm._e()
              ]
            ),
            _c(
              "div",
              {
                class: ["dots-button", { active: _vm.showActions }],
                on: {
                  click: function($event) {
                    _vm.showActions = !_vm.showActions
                  }
                }
              },
              [
                _c("f-sprite-icon", {
                  attrs: { "icon-link": _vm.$options.icons.IconDots.id }
                }),
                _c(
                  "ui-dropdown",
                  {
                    attrs: { right: "", visible: _vm.showActions },
                    on: {
                      "on-close": function($event) {
                        _vm.showActions = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "actions" }, [
                      !_vm.isPrimary
                        ? _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.$emit("on-primary")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            Сделать основным\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$emit("on-edit")
                            }
                          }
                        },
                        [_vm._v("\n            Редактировать\n          ")]
                      ),
                      _c("span", { on: { click: _vm.remove } }, [
                        _vm._v("\n            Удалить\n          ")
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          ]
        : [
            _c(
              "div",
              {
                class: ["button", { disabled: _vm.disabled }],
                on: {
                  click: function($event) {
                    return _vm.$emit("open")
                  }
                }
              },
              [
                _c(
                  "div",
                  [
                    _c("f-sprite-icon", {
                      attrs: { "icon-link": _vm.$options.icons.IconPlus.id }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v(_vm._s(_vm.button))])
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }